import React, { useEffect, useMemo, useState } from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import AdvanceTable from 'components/common/advance-table/advanceTable';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/advanceTableProvider';
import SubtleBadge from "components/common/subtleBadge";
import corner4 from "assets/img/illustrations/corner-4.png";
import Background from "components/common/background";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { fetchRoleAndClaims, handleLoadingAndAccess } from "../../assets/js/common";

const ReleaseNotes = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);
  const [prevLocationId, setPrevLocationId] = useState(() => localStorage.getItem('LocationId'));

  const releaseNotesData = useMemo(() => [
    {
      serviceUpdate: '27-10-2026',
      features: [
        t("releaseNotesFeatures.employeeAttendanceDetailPanel"),
        t("releaseNotesFeatures.settingsNetworkErrorPopupFix"),
      ],
      status: "published",
      releaseNo: '1.1.2'
    },
    {
      serviceUpdate: '21-10-2026',
      features: [
        t("releaseNotesFeatures.pushNotifications"),
        t("releaseNotesFeatures.taskDetailsTimeDisplay"),
        t("releaseNotesFeatures.proposalJobFrequencyDisplay"),
        t("releaseNotesFeatures.hoursRegistrationPdfFormatting"),
        t("releaseNotesFeatures.hindiTranslations"),
        t("releaseNotesFeatures.financialSectionDuplicateUploads"),
        t("releaseNotesFeatures.bulkImportImprovements"),
        t("releaseNotesFeatures.hoursRegistrationExportAccuracy"),
        t("releaseNotesFeatures.approvedProposalDropdown"),
        t("releaseNotesFeatures.proposalStatusConsistency"),
        t("releaseNotesFeatures.attendanceFloatingTimer"),
        t("releaseNotesFeatures.attendanceExportLabel"),
      ],
      status: "published",
      releaseNo: '1.1.2'
    },
    {
      serviceUpdate: '13-10-2026',
      features: [
        t("releaseNotesFeatures.employeeClockInClockOut"),
        t("releaseNotesFeatures.adminAttendanceOverview"),
      ],
      status: "published",
      releaseNo: '1.1.2'
    },
    {
      serviceUpdate: '06-10-2026',
      features: [
        t("releaseNotesFeatures.leaveManagementSummaryWidgetsPerformance"),
        t("releaseNotesFeatures.autoCreateSixMonthOrder"),
        t("releaseNotesFeatures.improvedContactPersonDetails"),
        t("releaseNotesFeatures.improvedOnboardingGuideTutorial"),
        t("releaseNotesFeatures.importUsersCsvExcel"),
        t("releaseNotesFeatures.relationsScreensPerformanceImprovement"),
      ],
      status: "published",
      releaseNo: '1.1.2'
    },
    {
      serviceUpdate: '22-09-2026',
      features: [
        t("releaseNotesFeatures.taskAssignmentSpecialities"),
        t("releaseNotesFeatures.planningOrderCreationFix"),
        t("releaseNotesFeatures.editProposalImprovement"),
        t("releaseNotesFeatures.newOrderImprovement"),
        t("releaseNotesFeatures.hourRegistrationPerformance"),
      ],
      status: "published",
      releaseNo: '1.1.1'
    },
     {
      serviceUpdate: '08-09-2026',
      features: [
        t("releaseNotesFeatures.clientComplaints"),
        t("releaseNotesFeatures.loginPersistence"),
        t("releaseNotesFeatures.onboardingGuide"),
      ],
      status: "published",
      releaseNo: '1.1.1'
    },
        {
      serviceUpdate: '01-09-2026',
      features: [
        t("releaseNotesFeatures.configureProposalRecurrence"),
        t("releaseNotesFeatures.clientTaskReviews"),
        t("releaseNotesFeatures.customWorkActivities"),
        t("releaseNotesFeatures.planningScreenPerformance")
      ],
      status: "published",
      releaseNo: '1.1.1'
    },
    {
      serviceUpdate: '25-08-2026',
      features: [
        t("releaseNotesFeatures.clientPortalAccess"),
        t("releaseNotesFeatures.managerAssignmentEmploymentType"),
        t("releaseNotesFeatures.orgNotificationManagement"),
        t("releaseNotesFeatures.employeeAvailabilityValidation"),
        t("releaseNotesFeatures.overdueMissedTaskNotificationJob"),
        t("releaseNotesFeatures.userSpecialitiesByBusinessType"),
        t("releaseNotesFeatures.clientTaskPhotoUploadNotes"),
        t("releaseNotesFeatures.proposalScreensPerformanceImprovement"),
        t("releaseNotesFeatures.crashRecoveryErrorScreen"),
        t("releaseNotesFeatures.proposalTemplateOrderFix"),
      ],
      status: "published",
      releaseNo: '1.1.1'
    },
    {
      serviceUpdate: '28-07-2026',
      features: [
        t("releaseNotesFeatures.improvedEditRelationStepWizard"),
        t("releaseNotesFeatures.orderScreensPerformanceOptimization"),
      ],
      status: "published",
      releaseNo: '1.1.1'
    },
    {
      serviceUpdate: '21-07-2026',
      features: [
        t("releaseNotesFeatures.improvedEditUserStepWizard")
      ],
      status: "published",
      releaseNo: '1.1.1'
    },
    {
      serviceUpdate: '14-07-2026',
      features: [
        t("releaseNotesFeatures.UpdateOrdersApprovedProposalVersion"),
        t("releaseNotesFeatures.ImprovedClientUserCreation"),
        t("releaseNotesFeatures.ApprovedProposalClientChangeWarning")
      ],
      status: "published",
      releaseNo: '1.1.1'
    },
    {
      serviceUpdate: '30-06-2026',
      features: [
        t("releaseNotesFeatures.renamedLocationToBranch"),
        t("releaseNotesFeatures.branchFinancialDetails"),
        t("releaseNotesFeatures.proposalVersioning"),
        t("releaseNotesFeatures.plannedCompletedHours"),
        t("releaseNotesFeatures.allClientInvoices"),
        t("releaseNotesFeatures.invoiceGenerationBillingCycle")
      ],
      status: "published",
      releaseNo: '1.1.1'
    },
    {
      serviceUpdate: '16-06-2026',
      features: [
        t("priceBasedProposalGeneration"),
        t("taskCompletionPhotoFeature"),
        t("approvedProposalSignatureFix"),
        t("proposalEditErrorFix"),
        t("taskScheduleAndDurationFix"),
        t("timezoneFix"),
        t("relationDataImport"),
        t("proposalDocumentAttachment")
      ],
      status: "published",
      releaseNo: '1.1.1'
    },
    {
      serviceUpdate: '03-06-2026',
      features: [
        t("manualWorkflowStepCompletion"),
        t("planningScreenPerformance")
      ],
      status: "published",
      releaseNo: '1.1.1'
    },
    {
      serviceUpdate: '20-05-2026',
      features: [
        t("emailOtpLogin"),
        t("emailConfigurationValidation"),
        t("newClientsDashboard"),
      ],
      status: "published",
      releaseNo: '1.1.1'
    },
    {
      serviceUpdate: '23-04-2026',
      features: [
        t("invoiceGeneration"),
        t("pdfOptimization"),
        t("performanceImprovement"),
        t("orderCreationFix"),
        t("digitalSignatureForEmployeeDashboard")
      ],
      status: "published",
      releaseNo: '1.1.0'
    },
    {
      serviceUpdate: '09-04-2026',
      features: [
        t("globalSearch"),
        t("planningScreen"),
        t("sickLeaveFunctionality"),
        t("notificationsImprovement"),
        t("digitalSignature")
      ],
      status: "published",
      releaseNo: '1.0.7'
    },
    {
      serviceUpdate: '13-03-2026',
      features: [
        t("ImprovedDashboard")
      ],
      status: "published",
      releaseNo: '1.0.6'
    },
    {
      serviceUpdate: '09-03-2026',
      features: [
        t("asperionClientSync"),
        t("unavailabilityRequests")
      ],
      status: "published",
      releaseNo: '1.0.6'
    },
    {
      serviceUpdate: '23-02-2026',
      features: [
        t("OrderDetailsUIEnhancement"),
        t("OrderDetailsTabsIntroduction"),
        t("GlobalSearchUIAdded"),
        t("VerticalMenuFix")
      ],
      status: "published",
      releaseNo: '1.0.6'
    },
    {
      serviceUpdate: '13-02-2026',
      features: [
        t("defaultDuration"),
        t("oneTimeEndDate"),
        t("endDateGeneration"),
        t("startedOrderWarning"),
        t("filterRetention"),
        t("noDataMessage")
      ],
      status: "published",
      releaseNo: '1.0.6'
    },
    {
      serviceUpdate: '05-01-2026',
      features: [
        t("weeklyPlanningConsolidatedEmail"),
        t("planningEmployeeExpandCollapse"),
        t("planningEmployeeMutations"),
        t("removeEmployeeFromJobs"),
        t("usersMultipleLocations"),
        t("duplicateRelationAsperionFix"),
        t("userAccessLevelImprovements"),
        t("orderFromExpiredProposal"),
        t("unselectDaysInOrder"),
        t("orderStatusAutoUpdate"),
        t("importExistingProposals")
      ],
      status: "published",
      releaseNo: '1.0.6'
    },
    {
      serviceUpdate: '26-11-2025',
      features: [
        t("orderCreationFromPlanning"),
        t("workTypeSaveFix"),
        t("taskFrequencyEmailFix"),
        t("hourRegistrationUpdateFix")
      ],
      status: "published",
      releaseNo: '1.0.5'
    },
    {
      serviceUpdate: '21-11-2025',
      features: [
        t("templatesCrud"),
        t("notificationDashboardImprovements")
      ],
      status: "published",
      releaseNo: '1.0.5'
    },
    {
      serviceUpdate: '05-11-2025',
      features: [
        t("fixedAsperionSync"),
        t("ViewAndCompleteOlderTasks")
      ],
      status: "published",
      releaseNo: '1.0.5'
    },
    {
      serviceUpdate: '30-10-2025',
      features: [
        t("improvedDeleteUserFunctionality"),
        t("fixedCreatedByDisplayIssue")
      ],
      status: "published",
      releaseNo: '1.0.5'
    },
    {
      serviceUpdate: '21-10-2025',
      features: [
        t("fixedProposalContentIssue")
      ],
      status: "published",
      releaseNo: '1.0.5'
    },
    {
      serviceUpdate: '17-10-2025',
      features: [
        t("adminResetPassword"),
        t("handlePastOrders"),
        t("templateSectionsDB")
      ],
      status: "published",
      releaseNo: '1.0.5'
    },
    {
      serviceUpdate: '10-10-2025',
      features: [
        t("inAppNotifications"),
        t("autoGeneratedPasswords"),
        t("settingsUiImproved"),
        t("asperionSyncToggle")
      ],
      status: "published",
      releaseNo: '1.0.5'
    },
    {
      serviceUpdate: '30-09-2025',
      features: [
        t("userInactivation"),
        t("improvedProposalTemplates")
      ],
      status: "published",
      releaseNo: '1.0.5'
    },
    {
      serviceUpdate: '25-09-2025',
      features: [
        t("apiSecurity"),
        t("detailedLogging"),
        t("uiImprovements"),
      ],
      status: "published",
      releaseNo: '1.0.4'
    },
    {
      serviceUpdate: '18-09-2025',
      features: [
        t("proposalStatusUpdate"),
        t("proposalTemplateSalutation"),
        t("adminMenusVisibility"),
      ],
      status: "published",
      releaseNo: '1.0.4'
    },
    {
      serviceUpdate: '10-09-2025',
      features: [
        t("relationsProposalsFromOrders"),
        t("planningFilter"),
        t("exportHourRegistration"),
        t("userOverviewByLocation"),
        t("oneTimeTasks"),
        t("breakTimeFeature"),
        t("uiImprovement")
      ],
      status: "published",
      releaseNo: '1.0.4'
    },
    {
      serviceUpdate: '30-08-2025',
      features: [
        t("emailNotifications"),
        t("employeeDashboardInAdminPortal"),
        t("persistentLogin"),
        t("hourRegistration")
      ],
      status: "published",
      releaseNo: '1.0.4'
    },
    {
      serviceUpdate: '05-08-2025',
      features: [
        t("accurateTimeTracking"),
        t("clientSpecificDashboard"),
        t("hourRegistrationDisplay"),
        t("orderProcessingInitiation")
      ],
      status: "published",
      releaseNo: '1.0.3'
    },
    {
      serviceUpdate: '02-07-2025',
      features: [
        t("orderDelete"),
        t("employeeAssignment"),
        t("asperionSyncEnabled"),
        t("proposalEmail")
      ],
      status: "published",
      releaseNo: '1.0.3'
    },
    {
      serviceUpdate: '09-06-2025',
      features: [
        t("taskManagement"),
        t("orderManagement"),
        t("generalSettings"),
        t("faqsWithVideo")
      ],
      status: "published",
      releaseNo: '1.0.2'
    },
    {
      serviceUpdate: '28-03-2025',
      features: [t("integrationWithAsperion")],
      status: "published",
      releaseNo: '1.0.1'
    },
    {
      serviceUpdate: '31-12-2024',
      features: [
        t("adminPortalBasicFeatures"),
        t("securePortalAdminData"),
        t("infrastructureAndServerSetup"),
        t("prospectManagement"),
        t("quotationProcessDigitalSigning"),
        t("customerAdministration"),
        t("adminAccountManagement")
      ],
      status: "published",
      releaseNo: '1.0.0'
    }
  ], [i18n.language]);

  const [data, setData] = useState(releaseNotesData);

  useEffect(() => {
    setData(releaseNotesData);
  }, [releaseNotesData]);

  useEffect(() => {
          fetchRoleAndClaims({
            navigate,
            claimType: "release-notes",
            claimValue: "view",
            setHasAccess,
            setIsLoading,
          });
  }, [navigate]);

  useEffect(() => {
    const handleLocationIdChange = () => {
      const currentLocationId = localStorage.getItem('LocationId');
      if (prevLocationId && currentLocationId !== prevLocationId) {
        navigate('/dashboard');
      }
      setPrevLocationId(currentLocationId);
    };
    const interval = setInterval(handleLocationIdChange, 500);
    return () => clearInterval(interval);
  }, [prevLocationId]);

  const columns = useMemo(() => [
    {
      accessorKey: 'serviceUpdate',
      header: t("serviceUpdate"),
      meta: {
        headerProps: { className: 'text-900' },
        cellProps: { className: 'text-nowrap' }
      }
    },
    {
      accessorKey: 'features',
      header: t("features"),
      cell: ({ cell }) => (
        <ul className="mb-0 ps-3">
          {cell.getValue().map((feature, index) => (
            <li key={index}>{feature}</li>
          ))}
        </ul>
      ),
      meta: {
        headerProps: { className: 'text-900' },
        cellProps: { className: 'text-wrap' }
      }
    },
    {
      accessorKey: 'status',
      header: t("status"),
      cell: ({ cell }) => {
        const status = cell.getValue();
        return (
          <SubtleBadge
            pill
            bg={status === "published" ? "success" : "danger"}
            className="d-flex flex-center"
          >
            <p className="mb-0 data-font-size">
              {status === "published" ? t("published") : t("unpublished")}
            </p>
          </SubtleBadge>
        );
      },
      meta: {
        cellProps: { className: '' },
        headerProps: { className: 'text-900' }
      }
    },
    {
      accessorKey: 'releaseNo',
      header: t("releaseNo"),
      meta: {
        cellProps: { className: '' },
        headerProps: { className: 'text-900' }
      }
    }
  ], [i18n.language]);

  const table = useAdvanceTable({
    data,
    columns,
    sortable: true,
    pagination: false
  });

 const loadingOrRedirect = handleLoadingAndAccess(
    isLoading,
    hasAccess,
    );

    if (loadingOrRedirect) {
    return loadingOrRedirect; // Render the loading spinner or handle navigation
    }

  return (
    <AdvanceTableProvider {...table}>
      <Row className="g-3 mb-3">
        <Col lg={12}>
          <Card className="mb-3 h-100">
            <Background image={corner4} className="bg-card" />
            <Card.Body className="position-relative pe-3 pb-2">
              <Row className="flex-between-center">
                <Col md>
                  <h5 className="mb-2 mb-md-0">{t("releaseNotes")}</h5>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Card className="h-100">
        <Card.Body className="p-0">
          {data.length > 0 ? (
            <AdvanceTable
              rows={table.rows}
              headerClassName="bg-200 text-nowrap align-middle"
              rowClassName="align-middle white-space-nowrap"
              tableProps={{
                bordered: true,
                striped: true,
                size: "sm",
                className: "mb-0 overflow-hidden data-font-size table-hover",
              }}
            />
          ) : (
            <div className="p-3 text-center">{t("noDataAvailableText")}</div>
          )}
        </Card.Body>
      </Card>
    </AdvanceTableProvider>
  );
};

export default ReleaseNotes;